import {Component, Input, Output, EventEmitter} from '@angular/core';
import moment from "moment";
import {NavController, PopoverController, Tabs} from "ionic-angular";
import {ShopStaffHoursPopoverPage} from "../../pages/shop-staff-hours-popover/shop-staff-hours-popover";
import {TeamServiceProvider} from "../../providers/team-service/team-service";
import { CoffeShopService } from '../../providers/coffe-shop/coffe-shop.service';

@Component({
  selector: 'shop-staff-hours',
  templateUrl: 'shop-staff-hours.html'
})
export class ShopStaffHoursComponent {

  @Input() shop: any;
  @Input() showClosedMessage: boolean = false;
  @Input() shopType: 'coffeShop' | 'barberShop';
  @Input() component: 'queue' | 'about';
  @Output() selectHoursEvent = new EventEmitter();
  shopStaffHours: any;
  allStaff: any;
  errors: {};
  loading: boolean;
  openNext: any = null;
  private tuid: string;

  constructor(
    public popoverCtrl: PopoverController,
    private teamProvider: TeamServiceProvider,
    private navCtrl: NavController,
    public coffeShopService: CoffeShopService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.teamProvider.getOpeningHours(this.shop.id).then((openingHours: any) => {
      this.shopStaffHours = openingHours.hours;
      this.allStaff = openingHours.staff;
      this.setActiveAccordion();

      this.loading = false;
    }).catch((error) => {
      this.loading = false;
    })
  }

  openingTime(shop) {
    if (!shop.closed) {
      return shop.open_at_string + ' - ' + shop.close_at_string;
    }

    return 'Closed';
  }

  infoPopover(day, staff) {

    this.tuid = localStorage.getItem('tuid');

    if (!this.tuid) {
        this.setReferral(0, 5);
        return;
    }

    let checkinPopover = this.popoverCtrl.create(ShopStaffHoursPopoverPage,
      {
        shop: this.shop,
        day: day,
        allStaff: this.allStaff,
        staff: staff,
        navCtrl: this.navCtrl
      },
      {
        enableBackdropDismiss: false
      });

    checkinPopover.present();

    checkinPopover.onDidDismiss(() => {

    })
  }

  setReferral(referral, tab) {
    localStorage.setItem('refer', String(referral));
    let tabBar: Tabs = this.navCtrl.parent;
    tabBar.select(tab);
  }

  toggleAccordion(event, index) {
    // Prevent toggle if shop is closed
    if (this.shopStaffHours[index].shop.closed === true) return;
    if (this.shopStaffHours[index].active === true) {
      return this.shopStaffHours[index].active = false;
    }
    return this.shopStaffHours[index].active = true;
  }

  setActiveAccordion() {
    let today = moment().format('dddd');
    let currentDayOfWeek = parseInt(moment().format('E'));
    let reachedEndOfWeek = false;
    let roundTrips = 0;
    for(let i = 0; i < this.shopStaffHours.length; i++) {
      let day = this.shopStaffHours[i];
      let dayOfWeek = i + 1;
      if (day.name === today && day.shop.is_after_close_at === false && day.shop.is_before_open_at === true && reachedEndOfWeek === false){
        this.openNext = this.shopStaffHours[i];
        return this.shopStaffHours[i].active = true;
      } else if (dayOfWeek > currentDayOfWeek && day.shop.closed === false  && reachedEndOfWeek === false){
        this.openNext = this.shopStaffHours[i];
        return this.shopStaffHours[i].active = true;
      } else if (reachedEndOfWeek === true && day.shop.closed === false){
        this.openNext = this.shopStaffHours[i];
        return this.shopStaffHours[i].active = true;
      }

      // If we get to the end of the week and have still not set a day as active
      // then we need to loop from the beginning to find when the shop is open the following week
      if (dayOfWeek === 7 && roundTrips ===0){
        reachedEndOfWeek = true;
        i = -1; // reset the loop back to the start
        roundTrips++; // stop infinite loop if cant find a day
      }

    }
  }

  openNextString(){
    if (this.openNext) {
      let today = moment().format('dddd');
      let tomorrow = moment().add(1, 'days').format('dddd');
      if (this.openNext.name === today) {
        return `We are currently closed, open again today at ${this.openNext.shop.open_at_string}!`;
      } else if (this.openNext.name === tomorrow){
        return `We are currently closed, open again tomorrow at ${this.openNext.shop.open_at_string}!`;
      } else {
        return `We are currently closed, open again on ${this.openNext.name} at ${this.openNext.shop.open_at_string}!`;
      }
    } else {
      return null;
    }
  }

  public makeBooking(data): void {
    this.selectHoursEvent.emit({component: this.component, data});
  }
  public addSpaceToTime(value: string) {
    if (!value) { return value; }
    value = value.toLocaleLowerCase();
    return value.includes('am') ? value.split('am').join(' AM') : value.split('pm').join(' PM');
  }
}



// WEBPACK FOOTER //
// ./src/components/shop-staff-hours/shop-staff-hours.ts